export default __webpack_public_path__ + "static/anja-friedensdorf-interview-4e95aba57d21be81f7be56a4ba6a705d.jpg";